import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { linkStyles } from "../styles.js";
import { HIDE_PASSWORD, SHOW_PASSWORD } from "../base/svgs.js";

@customElement("fl-login-page")
class LoginPage extends LitElement {
  @property({ type: String })
  accessor csrfToken: string = "bad_token";
  @property({ type: String })
  accessor errorMessage: string = "";
  @property()
  accessor showLocalAccountForm: boolean = false;
  
  static override styles = [
    css`
      :host {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        background-color: var(--panel-color);
        padding: 10px;
        height: 80vh;
      }
      
      #error {
        color:var(--red-alert-bright);
        padding-bottom: 10px;
      }

      sl-card {
        text-align: center;
        --border-radius: var(--panel-border-radius);
      }

      #card-header-text {
        font-weight: 400;
        font-style: normal;
        font-size: 24px;
        padding: 10px;
      }

      #sso-panel {
        padding-top: 15px;
        color: var(--sl-color-gray-600);
      }

      hr.frame-text {
        display: inline-block;
        width: 25%;
        border: none;
        border-top: 1px solid;
        height: 0;
        margin: 0 10px;
        vertical-align: middle;
      }

      #header-logo {
        height: 125px;
        width: 125px;
        display: block;
        margin: auto;
        border-radius: 50%;
        border: 2px solid transparent;
        transition: all 2.7s ease;
        animation: pulse-logo 9s infinite;
      }
      .footer {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100vw;
        background: linear-gradient(90deg, var(--panel-color), var(--sl-color-gray-100), var(--panel-color)), var(--panel-color);
        color: var(--sl-color-gray-700);
        text-align: center;
        font-size: 1em;
        font-style: normal;
        padding: 1em 0 0.5em 0;
        z-index: 10;
        box-shadow: 0 -2px 12px 0 rgba(0,0,0,0.07);
        letter-spacing: 1px;
        opacity: 1;
        overflow: visible;
      }
      .footer > div {
        margin: 0.5em 0;
      }
      .footer-version {
        font-size: 0.5em;
        color: var(--sl-color-gray-900);
        margin-top: 0.2em;
        margin-bottom: 0.2em;
      }
      .footer-glow {
        position: fixed;
        left: 0;
        bottom: 100px;
        width: 100vw;
        height: 32px;
        pointer-events: none;
        z-index: 5;
      }
      .footer-glow-inner {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 32px;
        box-shadow: 0 -12px 32px 8px var(--primary-color);
        border-radius: 50% 50% 0 0;
        opacity: 0.5;
      }
      @media (max-width: 600px) {
        .footer {
          font-size: 0.85em;
          padding: 0.7em 0 0.3em 0;
        }
        .footer-divider {
          font-size: 0.95em;
        }
      }
    `,
    css`
      @keyframes pulse-logo {
        0% {
          transform: scale(1);
          filter: none;
          border: 2px solid transparent;
        }
        50% {
          transform: scale(0.90);
          filter: drop-shadow(0 0 8px var(--primary-color));
          border: 2px solid var(--primary-color);
        }
        100% {
          transform: scale(1);
          filter: none;
          border: 2px solid transparent;
        }
      }
    `,linkStyles
  ];
  
  protected override render(): unknown {
    return html`
      <sl-card>
        <div slot="header">
          <img id="header-logo" src="/imgs/logo.png" alt="Logo" />
          <div id="card-header-text">
            Sign in to FlightLogik
          </div>
        </div>
        ${this.errorMessage && this.errorMessage != "None" ? html`
            <div id="error">
              ${this.errorMessage}
            </div>
          `
          : null
        }
        ${this.showLocalAccountForm ? html`
            <form action="/login" method="post">
              <sl-input name="username" placeholder="Username" autocomplete="off"></sl-input><br>
              <sl-input type="password" name="password" placeholder="Password" password-toggle>${HIDE_PASSWORD}${SHOW_PASSWORD}</sl-input><br>

              <sl-button type="submit" variant="default">
                Login
              </sl-button>
              <input type="hidden" name="_csrf_token" value="${this.csrfToken}">
            </form>
          `
          : null
        }
        <div id="sso-panel">
          ${this.showLocalAccountForm ? html`
              <hr class="frame-text">or continue with<hr class="frame-text"><br><br>
            `
            : html`
              Click below to login with single sign-on.<br><br>
            `
          }
          <sl-button href="/auth/login" variant="default" >
            <img src="/imgs/keycloak_icon.svg" alt="Keycloak Logo" style="height:20px;vertical-align:middle;" />
            Keycloak
          </sl-button>
        </div>
        <div slot="footer" style="color: var(--sl-color-gray-600);">
          Need help? Please contact: <a href="mailto:michael.scott@rmit.edu.au">michael.scott@rmit.edu.au</a>
        </div>
        
      </sl-card>
      <div class="footer-glow">
        <div class="footer-glow-inner"></div>
      </div>
      <footer class="footer">
        <div>© ${new Date().getFullYear()} RMIT University. All rights reserved.</div>
        <div style="font-weight: bold; font-size: 1em;">Powered by</div>
        <div style="display: flex; align-items: center; justify-content: center; gap: 16px; margin-top: 0.5em; margin-bottom: 0.5em;">
          <img src="/imgs/RMIT_University_SLWDAC.png" alt="RMIT University" style="height:54px;vertical-align:middle;" />
          <img src="/imgs/Defence_Science_Technology_Group_DSTG.png" alt="DSTG" style="height:54px;vertical-align:middle;" />
        </div>
      </footer>
    `;
  }
}
